<script setup>
import { computed } from 'vue';
import CreateIssue from './CreateIssue.vue';

const props = defineProps({
  accountId: {
    type: [Number, String],
    required: true,
  },
  conversation: {
    type: Object,
    required: true,
  },
  integrationId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['close']);

const contact = computed(() => {
  const {
    meta: {
      sender: { phone_number = null, email = null, name = null } = {},
    } = {},
  } = props.conversation;
  return {
    phone: phone_number ? phone_number.replace(/\D/g, '') : null,
    email,
    name,
  };
});

const onClose = () => {
  emit('close');
};
</script>

<template>
  <div class="flex flex-col h-auto">
    <div class="flex flex-col h-auto">
      <div class="flex flex-col px-8 py-8">
        <CreateIssue
          :account-id="accountId"
          :conversation-id="conversation.id"
          :additional-attributes="conversation.additional_attributes"
          :contact="contact"
          :integration-id="integrationId"
          @close="onClose"
          @submit="onClose"
        />
      </div>
    </div>
  </div>
</template>
